// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"59b5b318","319":"3f951ae6","410":"4ffc3dee","440":"1d57e315","455":"ad116f57","488":"f5b04218","503":"e42eb925","593":"e2c4583c","612":"53045e0b","860":"79c02945","883":"4b4048f9","977":"8e61b48a"}[chunkId] + ".chunk.js";
};